<template>
	<div class="display-flex flex-row flex-centerize">
		<AppTooltip v-if="hasEditPermissions" position="top" :disabled="isThereWidgetTitle" text="Click here to add a title">
			<AnemicButton
				@click.stop="openPageOptions"
				class="icon-and-text-button mr-1 flex-centerize"
				:class="{ selected: isPageOptionsSelected }"
			>
				<SIcon :name="`modal-page-options${isPageOptionsSelected ? '-selected' : ''}`" class="button-icon mr-1" :width="13" />
				Page options
			</AnemicButton>
		</AppTooltip>
		<AnemicButton @click="$emit('show-preview')" class="icon-and-text-button flex-centerize">
			<SIcon class="button-icon mr-1" name="modal-preview" :width="14" />
			Preview
		</AnemicButton>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppTooltip from '@/components/common/AppTooltip';
export default {
	name: 'WidgetLayoutSettings',
	props: {
		sideBarFocus: { type: String },
		hasEditPermissions: { type: Boolean },
	},
	components: {
		AppTooltip,
	},
	computed: {
		...mapGetters('widgetEditor', ['widgetMetadata']),
		widgetTitle() {
			return this.widgetMetadata.options.title || {};
		},
		isThereWidgetTitle() {
			return Boolean(this.widgetTitle.active);
		},
		isPageOptionsSelected() {
			return this.sideBarFocus === 'options';
		},
	},
	methods: {
		openPageOptions() {
			this.$emit('focus-on-page-options');
		},
	},
};
</script>
<style scoped lang="scss">
.icon-and-text-button {
	font-size: 12px !important;
	color: var(--primary-font-color) !important;

	padding: 10px 8px !important;
	border-radius: 8px !important;
	background: var(--bg-color) !important;
	border: 1px solid var(--button-border) !important;

	&.selected {
		color: var(--primary-color) !important;
		background: var(--selected-button-background) !important;
	}

	.button-icon {
		margin-top: 2px;
	}
}
</style>
